// extracted by mini-css-extract-plugin
export default {"wrapper":"VesEventsTable_wrapper__zsP7-","tableContainer":"VesEventsTable_tableContainer__juJaY"};